import { StatusEnum } from '../../Enum/StatusEnum';
import BaseEntity from '../BaseEntity.model';
import { Barrier } from '../CarePlans/Barrier.model';
import { CreatedBy } from '../Shared/CreatedBy.model';

export default interface ICulturalConsiderationsModel extends BaseEntity {
    MemberId: string;
    RecordingDate: Date;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    MeaningfulActivities: string;
    IsAIMeaningfulActivities: boolean;
    CommunitySupportSelfHelp: string;
    IsAICommunitySupportSelfHelp: boolean;
    SpiritualOrReligiousAffiliation: string;
    IsAISpiritualOrReligiousAffiliation: boolean;
    PreferredReligiousOrBeliefSystem: string;
    IsAIPreferredReligiousOrBeliefSystem: boolean;
    PreferredReligiousOrBeliefSystemAnswer: string;
    IsAIPreferredReligiousOrBeliefSystemAnswer: boolean;
    CulturalEthnicInfoConcerns: string;
    IsAICulturalEthnicInfoConcerns: boolean;
    CulturalBarriers: Barrier;
    IsAICulturalBarriers: boolean;
    NoBarriers: boolean;
    AssessmentStatus: StatusEnum;
}

export class CulturalConsiderationsModel implements ICulturalConsiderationsModel {
    Id: string;
    MemberId: string;
    RecordingDate: Date;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    MeaningfulActivities: string;
    CommunitySupportSelfHelp: string;
    SpiritualOrReligiousAffiliation: string;
    PreferredReligiousOrBeliefSystem: string;
    PreferredReligiousOrBeliefSystemAnswer: string;
    CulturalEthnicInfoConcerns: string;
    CulturalBarriers: Barrier;
    NoBarriers: boolean;
    AssessmentStatus: StatusEnum;
    IsAIMeaningfulActivities: boolean;
    IsAICommunitySupportSelfHelp: boolean;
    IsAISpiritualOrReligiousAffiliation: boolean;
    IsAIPreferredReligiousOrBeliefSystem: boolean;
    IsAIPreferredReligiousOrBeliefSystemAnswer: boolean;
    IsAICulturalEthnicInfoConcerns: boolean;
    IsAICulturalBarriers: boolean;

    constructor() {
        this.Id = '';
        this.MemberId = '';
        this.MemberName = '';
        this.AssessmentStatus = 0;
        this.NoBarriers = false;
    }
}
